import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from '../../components/Footer'
import AboutHomeImage from '../../assets/about-us-home-image.png'
import foodImage from '../../assets/Food & Beverage.jpg'
import Hotel from '../../assets/Hotels.jpg'
import Startups from '../../assets/Startups.jpg'
import Retail from '../../assets/Retail.jpg'
import ReasonsImage from '../../assets/Reasons-image.png'
import valueimage1 from '../../assets/value-image-1.png'
import valueimage2 from '../../assets/value-image-2.png'
import valueimage3 from '../../assets/value-image-3.png'
import valueimage4 from '../../assets/value-image-4.png'
import SupportImage from '../../assets/support-image.png'
import TickImage from '../../assets/tick-image.png'
import sendMessageImage from '../../assets/send-message-image.png'
import GraphImage from '../../assets/graph-image.png'
import MessageIcon from '../../assets/message-icon-home-1.png'
import LocationIcon from '../../assets/location-icon-contactus.png'
import './Aboutus.css'

function Aboutus() {
    const [activeView, setActiveView] = useState('contact');
    const sectionRef = useRef(null);
    const navigate = useNavigate()

    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const handleRedirectToFleetEats = () => {
        navigate('/products/fleet-eats')
    }

    const handleRedirectToFleetHotels = () => {
        navigate('/products/fleet-stay')
    }

    const handleRedirectToFleetRetails = () => {
        navigate('/products/fleet-mart')
    }

    const handleRedirectToFleetOffice = () => {
        navigate('/products/fleet-office')
    }

    const [formData, setFormData] = useState({
        name: "",
        product: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        const phoneNumber = "+917386616587";
        const { name, product } = formData;

        const whatsappMessage = `Hey, I am ${name}.\n\nI am interested in ${product} POS.\n\nLooking forward to a demo!`;

        const encodedMessage = encodeURIComponent(whatsappMessage);

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
        setFormData({
            name: "",
            product: "",
        });
    };

    return (
        <>
            <Navbar />

            <div className="about-us-main-container">
                <div className="about-us-content-container">
                    <h1 className="about-us-heading">
                        Empowering Businesses with <span className="span-about-us">Smarter POS</span> Solutions
                    </h1>
                    <p className="about-us-description">
                        From restaurants to retail, hotels to corporates — we help businesses simplify operations and scale with confidence.
                    </p>
                    <button className="explore-journey-button" onClick={scrollToSection}>Explore Our Journey</button>
                </div>
                <img src={AboutHomeImage} alt="about-us-home-image" className="about-us-home-image" />
            </div>

            <div className="our-story-main-container">
                <div className="our-story-content-container">
                    <h1 className="our-story-heading">Our Story</h1>
                    <p className="our-story-description"><span className="our-story-span">FleetOrder</span> is a product of  SassyMonks Private Limited. With a passion for solving real-world problems, SassyMonks ventured into product development — and that’s how <span className="our-story-span">FleetOrder</span> was born.</p>
                    <div className="our-story-content">
                        <p className="our-story-description">At SassyMonks, we believe that running a restaurant should be simple, fast, and stress-free. That’s why we created FleetOrder — a POS and Contactless Dining system designed with small and medium business owners in mind.</p>
                        {/* <p className="our-story-description">During the COVID-19 pandemic, we saw how the Food & Beverage industry was shaken. This challenge inspired us to create something that helps restaurant owners not only manage operations effectively and at a lower cost, but also ensures customer safety.</p> */}
                        <p className="our-story-description">We wanted a solution that lets you:</p>
                        <ul>
                            <li className="our-story-description"><b>Complete orders in under 60 seconds</b> — no complicated steps, just fast billing.</li>
                            <li className="our-story-description"><b>Operate in your language</b> — so anyone, young or old, can use it effortlessly.</li>
                             <li className="our-story-description"><b>Reduce staff dependency</b> — QR code ordering lets customers place their own orders, saving time and effort.</li>
                            <li className="our-story-description"><b>Go digital easily</b> — manage inventory, track sales, and modernize your business without a steep learning curve.</li>
                        </ul>
                        <p className="our-story-description">FleetOrder was built to help businesses run smarter, serve customers faster, and thrive in a digital world. <b>Simple, intuitive, and cost-effective</b> — because when your restaurant succeeds, that’s our story too.</p>
                    </div>
                </div>
            </div>

            <div className="business-ecosystem-main-container">
                <div className="business-ecosystem-container">
                    <h1 className="business-ecosystem-heading">Empowering the Entire <span className="business-ecosystem-span">Business Ecosystem</span></h1>

                    <div className="business-ecosystem-cards-container">
                        <div className="business-ecosystem-card">
                            <img src={foodImage} alt="business-ecosystem-image" className="business-ecosystem-image" />
                            <div>
                                <h1 className="business-ecosystem-title">Food & Beverage</h1>
                                <p className="business-ecosystem-content">Complete restaurant billing with inventory management and order tracking.</p>
                                <button className="business-ecosystem-more-button" onClick={handleRedirectToFleetEats}>Know More</button>
                            </div>
                        </div>

                        <div className="business-ecosystem-card">
                            <img src={Retail} alt="business-ecosystem-image" className="business-ecosystem-image" />
                            <div>
                                <h1 className="business-ecosystem-title">Retail</h1>
                                <p className="business-ecosystem-content">Advanced POS system with barcode scanning and customer management.</p>
                                <button className="business-ecosystem-more-button" onClick={handleRedirectToFleetRetails}>Know More</button>
                            </div>
                        </div>

                        <div className="business-ecosystem-card">
                            <img src={Hotel} alt="business-ecosystem-image" className="business-ecosystem-image" />
                            <div>
                                <h1 className="business-ecosystem-title">Hotels & Stays</h1>
                                <p className="business-ecosystem-content">Comprehensive hospitality billing with room management features.</p>
                                <button className="business-ecosystem-more-button" onClick={handleRedirectToFleetHotels}>Know More</button>
                            </div>
                        </div>

                        <div className="business-ecosystem-card">
                            <img src={Startups} alt="business-ecosystem-image" className="business-ecosystem-image" />
                            <div>
                                <h1 className="business-ecosystem-title">Corporates</h1>
                                <p className="business-ecosystem-content">Scalable billing solutions that grow with your business a needs.</p>
                                <button className="business-ecosystem-more-button" onClick={handleRedirectToFleetOffice}>Know More</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            

            <div className="scalable-platform-main-container">
                <div className="scalable-card-container">
                    <div className="scalable-content-container">
                        <h1 className="reasons-heading">From a <span className="reason-span">Vision</span> to a Scalable Platform</h1>
                        <p className="scalable-description">We started with a simple mission — to eliminate complexities in billing and business operations. Today, our POS ecosystem powers hundreds of businesses across industries, helping them focus on growth while we take care of the technology.</p>
                        <div className="scalable-point-container">
                            <div>
                                <h1 className="comapny-count">500 +</h1>
                                <p className="company-name">Businesses</p>
                            </div>

                            <div>
                                <h1 className="comapny-count">99.9%</h1>
                                <p className="company-name">Uptime</p>
                            </div>

                            <div>
                                <h1 className="comapny-count">24/7</h1>
                                <p className="company-name">Support</p>
                            </div>

                        </div>
                    </div>
                    <img src={GraphImage} alt="graph-image" className="graph-image" />
                </div>
            </div>

            <div className="reasons-main-container">
                <h1 className="reasons-heading">Top 5 Reasons to Choose Our <span className="reason-span">POS Billing Softwares</span></h1>
                <div className="reasons-container">
                    <img src={ReasonsImage} alt="reasons-image" className="reasons-image" />
                    <div className="points-main-container">
                        <div className="point-container">
                            <h1 className="reasons-point-heading">✅ Effortless Billing Experience</h1>
                            <p className="reason-point-description">A simple and intuitive interface that your staff can master instantly — no lengthy training required. Faster checkouts, fewer errors, and a smooth experience for both staff and customers.</p>
                        </div>

                        <div className="point-container">
                            <h1 className="reasons-point-heading">✅ Enterprise-Grade Security</h1>
                            <p className="reason-point-description">Your business data stays protected with intelligent security controls, user access management, and encrypted backups — ensuring peace of mind at all times.</p>
                        </div>

                        <div className="point-container">
                            <h1 className="reasons-point-heading">✅ Frictionless Checkout at Lowest Cost</h1>
                            <p className="reason-point-description">Deliver a seamless checkout process with minimal investment and maintenance. No expensive hardware dependency — run efficiently with what you already have.</p>
                        </div>

                        <div className="point-container">
                            <h1 className="reasons-point-heading">✅ Anytime, Anywhere Access</h1>
                            <p className="reason-point-description">Use the POS on mobile, desktop, tablet, or browser — even offline. Manage your business operations from anywhere, whether you’re at the counter, on the move, or at home.</p>
                        </div>

                        <div className="point-container">
                            <h1 className="reasons-point-heading">✅ 100% Accurate Data & Insights</h1>
                            <p className="reason-point-description">No more manual errors — every calculation from MRP, selling price, taxes, discounts, multi-currency, offers is fully automated. Get real-time, error-free reports and analytics that empower better decisions.</p>
                        </div>

                    </div>
                </div>
            </div>

            <div className="values-main-container">
                <h1 className="reasons-heading">The <span className="reason-span">Values</span> That Drive Us</h1>
                <div className="values-cards-container">

                    <div className="values-card">
                        <img src={valueimage1} alt="value-image" className="value-image" />
                        <h1 className="value-title">Customer First</h1>
                        <p className="value-content">Every product decision is built around user success</p>
                    </div>

                    <div className="values-card">
                        <img src={valueimage2} alt="value-image" className="value-image" />
                        <h1 className="value-title">Innovation</h1>
                        <p className="value-content">Continuous upgrades & future-ready features</p>
                    </div>

                    <div className="values-card">
                        <img src={valueimage3} alt="value-image" className="value-image" />
                        <h1 className="value-title">Trust & Transparency</h1>
                        <p className="value-content">Secure, reliable, and honest operations</p>
                    </div>
                    <div className="values-card">
                        <img src={valueimage4} alt="value-image" className="value-image" />
                        <h1 className="value-title">Inclusivity</h1>
                        <p className="value-content">Solutions tailored for businesses of all sizes</p>
                    </div>
                </div>
            </div>

            <div className="support-us-main-container">
                <div className="supportcard-container">
                    <div>
                        <h1 className="reasons-heading">Support That <span className="reason-span">Never Sleeps</span></h1>
                        <div className="reasons-points">
                            <img src={TickImage} className="tick-image" alt="tick-image" />
                            <p className="reason-point">24/7 Support team for quick resolutions</p>
                        </div>
                        <div className="reasons-points">
                            <img src={TickImage} className="tick-image" alt="tick-image" />
                            <p className="reason-point">Dedicated onboarding & training</p>
                        </div>
                        <div className="reasons-points">
                            <img src={TickImage} className="tick-image" alt="tick-image" />
                            <p className="reason-point">Knowledge base & tutorials</p>
                        </div>
                        <button className="talk-our-expects-button" onClick={scrollToSection}>Talk to Our Experts</button>

                    </div>
                    <div>
                        <img src={SupportImage} alt="support-image" className="suport-image" />
                    </div>
                </div>
            </div>

            {/* <div className="contact-form-main-container-about">
                <div className="contact-form-content-container">
                    <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                    <h1 className="send-message-heading">Send us a Message</h1>
                    <p className="send-message-description">Fill out the form below and we'll get back to you within 24 hours.</p>
                </div>
                <form className="send-message-form-main">
                    <div className="send-message-form">
                        <div className="input-container">
                            <label>Full Name</label>
                            <input type="text" placeholder="John Doe" className="input-field" />
                        </div>
                        <div className="input-container">
                            <label>Email Address</label>
                            <input type="text" placeholder="john@example.com" className="input-field" />
                        </div>
                    </div>
                    <div className="input-container">
                        <label>Product</label>
                        <select className="input-field">
                            <option value="">Select a product</option>
                            <option value="product1">Product 1</option>
                            <option value="product2">Product 2</option>
                            <option value="product3">Product 3</option>
                        </select>
                    </div>

                    <div className="input-container">
                        <label>Message</label>
                        <textarea
                            placeholder="Type your message here..."
                            className="input-field"
                            rows="4"
                            style={{ minHeight: '100px' }}
                        ></textarea>
                    </div>

                    <button className="send-message-button">Send Message</button>

                </form>
            </div> */}

            <div className="contact-form-main-container-about" ref={sectionRef}>
                <div className="contact-form-content-container">
                    <div className="contactus-buttons-container">
                        <button
                            className={`contactus-form-buttons ${activeView === 'contact' ? 'active' : ''}`}
                            onClick={() => setActiveView('contact')}
                        >
                            <img src={MessageIcon} alt="message-icon" className="contact-form-icons" />
                            Contact Form
                        </button>

                        <button
                            className={`contactus-form-buttons ${activeView === 'location' ? 'active' : ''}`}
                            onClick={() => setActiveView('location')}
                        >
                            <img src={LocationIcon} alt="location-icon" className="contact-form-icons" />
                            Location
                        </button>
                    </div>



                    {activeView === 'contact' ? (
                        <>
                            <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                            <h1 className="send-message-heading">Book a Demo</h1>
                            <p className="send-message-description">
                                Fill out the form below and connect us instantly.
                            </p>

                            <form className="send-message-form-main" onSubmit={handleWhatsAppSubmit}>
                                <div className="send-message-form">
                                    <div className="input-container">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="John Doe"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {/* <div className="input-container">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@example.com"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div> */}
                                </div>

                                <div className="input-container">
                                    <label>Product</label>
                                    <select
                                        name="product"
                                        className="input-field"
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a product</option>
                                        <option value="Fleet Eats">Fleet Eats</option>
                                        <option value="Fleet Mart">Fleet Mart</option>
                                        <option value="Fleet Stay">Fleet Stay</option>
                                        <option value="Fleet Office">Fleet Office</option>
                                    </select>
                                </div>

                                {/* <div className="input-container">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="Type your message here..."
                                        className="input-field"
                                        rows="6"
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div> */}

                                <button type="submit" className="send-message-button">
                                    Connect Us
                                </button>
                            </form>
                        </>
                    ) : (
                        // Location View
                        <div className="map-image-background">
                            <div className="reach-out-cards-container">
                               <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5253765500493!2d78.37664357522262!3d17.434550583460727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e37831f177%3A0x32d4499d34baaa78!2sT-Hub%20Phase%202!5e0!3m2!1sen!2sin!4v1781782551831!5m2!1sen!2sin" 
                                width="600" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowfullscreen 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Thub Phase 2 Map"
                                ></iframe>
                            </div>
                        </div>

                    )}

                </div>
            </div>

            <Footer />

        </>
    )
}

export default Aboutus 